import React from 'react'
import { EnumTipoCicloFacturacion, EnumTipoFacturacion, EnumTipoSujeto } from '../../../api'
import { SettlementsInvoicesPage } from '../../settlements/invoices/settlements.invoices'

interface InvoiceCyclesFinishedPageProps {
  location?: {
    state?: {
      executionCycleId?: number
      invoiceCycleId?: number
      invoiceCycleType?: EnumTipoCicloFacturacion
      subjectType?: EnumTipoSujeto
      billingType?: EnumTipoFacturacion
    }
  }
}

export const InvoiceCyclesFinishedPage: React.FC<InvoiceCyclesFinishedPageProps> = ({
  location
}) => {
  const state = location?.state

  return (
    <SettlementsInvoicesPage
      location={{
        state: {
          executionCycleId: state?.executionCycleId,
          invoiceCycleId: state?.invoiceCycleId,
          invoiceCycleType: state?.invoiceCycleType,
          subjectType: state?.subjectType,
          billingType: state?.billingType,
          finishedExecutionCycle: true
        }
      }}
    />
  )
}
